import { render, staticRenderFns } from "./Registrati.vue?vue&type=template&id=d9a1ae28&scoped=true&"
import script from "./Registrati.vue?vue&type=script&lang=js&"
export * from "./Registrati.vue?vue&type=script&lang=js&"
import style0 from "./Registrati.vue?vue&type=style&index=0&id=d9a1ae28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a1ae28",
  null
  
)

export default component.exports